import { useStore } from '@nanostores/react';
import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { accountStore } from '@/services/auth/store';

/**
 * Whether the workspace is offered the Conversions tab.
 *
 * Two flags, and they are not both about conversions. `goals-to-conversions`
 * is this tab's own rollout. `show-goals` is the one that decides whether
 * goals exist for the workspace at all (FLO-4772): with it off, the goal page
 * every row opens renders Hydra's `NotFoundPage` (`routes/-goals-route.tsx`),
 * so a tab shown anyway would be a list where every row and every Add value
 * is a dead link. The nav hides the Goals item for the same reason.
 * Masquerading staff bypass both rollout gates so they can inspect a migrated
 * workspace before either feature is exposed to the customer account.
 */
export function useConversionsEnabled(): boolean {
  const account = useStore(accountStore);
  const hasConversionsTab = useFeatureFlag(AccountFeatureFlag.GoalsToConversions);
  const hasGoals = useFeatureFlag(AccountFeatureFlag.ShowGoals);

  return account?.is_masq === true || (hasConversionsTab && hasGoals);
}
